import * as types from '../actions/types';

const initialState = {
   page:1,
   success: false
}

export default function queryPageReducer(state = initialState, action = undefined) {
    switch (action.type) {
        case types.PAGE_QUERY:
            return{
                page:action.payload,
                success: true
            }
        default:
            return state
    }
}